import Login from "@/views/Login.vue";
const authRoutes = [
    {
        path: "/login",
        name: "Login",
        component: Login,
        // ログイン不要な画面はこの印を付ける（印が無い画面はログイン必須）。
        // 印は画面ごとに付ける。親ルートに付けても子ルートは公開にならない。
        meta: { public: true },
    },
];
export default authRoutes;
